var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-around"},[_c('div',[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"flex flex-col text-center"},[_c('div',{staticClass:"text-4xl"},[_vm._v(" "+_vm._s(_vm.valor))]),_vm._v(" "),_c('div',{staticClass:"uppercase text-xs text-gray-600"},[_vm._v(" "+_vm._s(_vm.legenda))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }